import { TrackTypeEnum } from '@/entities/tracks'

export type TracksListPageTabsKeys = Lowercase<
  Exclude<keyof typeof TrackTypeEnum, 'Jingle'>
>

export const DEFAULT_TRACKS_LIST_PAGE_TAB: TracksListPageTabsKeys = 'music'

export const TracksListPageTabsKeysTypesEnum: Record<
  TracksListPageTabsKeys,
  TrackTypeEnum
> = {
  music: TrackTypeEnum.Music,
  podcast: TrackTypeEnum.Podcast,
  sermon: TrackTypeEnum.Sermon,
  audiobook: TrackTypeEnum.AudioBook,
}

export const TracksListPageTabsKeysArray: TracksListPageTabsKeys[] = [
  'music',
  'podcast',
  'sermon',
  'audiobook',
]

export const TracksListPageTabsKeysEnum: Record<
  TracksListPageTabsKeys,
  TracksListPageTabsKeys
> = {
  music: 'music',
  podcast: 'podcast',
  sermon: 'sermon',
  audiobook: 'audiobook',
}
